import React from 'react';
import './Collaboration.css';

const Collaboration = ({ project }) => {
  return (
    <div className="collaboration-container">
      <div className="collaboration-content">
        <button className="enable-session-btn">
          <i className="fas fa-users"></i>
          <span>Enable Live Session</span>
        </button>
      </div>
    </div>
  );
};

export default Collaboration;